import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Statistic, StatisticProps } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import todayUser from '../assets/today-user.png';
import allUser from '../assets/all-user-group.png';
import CountUp from 'react-countup';
import axios from 'axios';
import { appConfig } from '../config/appConfig';
import ardekLogo from '../assets/ardek.png';
const formatter: StatisticProps['formatter'] = (value) => (
    <CountUp end={value as number} separator="," />
);
const StatsSection = () => {

    const [todayCount, setTodayCount] = useState(0);
    const [allCount, setAllCount] = useState(0);

    useEffect(() => {
        fetchCounter();
        // fetchAnnouncements(filter, sortedInfo, page);
    }, []);

    const fetchCounter = async () => {
        try {
            const response = await axios.get(appConfig.api.endPoint + '/api/ArdekCounter/UpdateArdekCounter');
            var result = response?.data?.result;
            if (result && !result.error) {
                setTodayCount(result.todayCount || 0);
                setAllCount(result.allCount || 0);
            } else {
                setTodayCount(0);
                setAllCount(0);
            }
        } catch (error) {
            setTodayCount(0);
            setAllCount(0);
        }
    };
    return (
        <Row gutter={[24, 24]} className="ankara-card-row">
            <Col xs={24} sm={7}>
                <a href="https://ardek.ankara.edu.tr">
                    <Card style={{ minHeight: '100%' }} bodyStyle={{ display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center' }}>
                        <img className='ardekLogo' src={ardekLogo} alt="Ankara Üniversitesi Araştırma Dekanlığı Logo" />
                    </Card>
                </a>
            </Col>
            <Col xs={24} sm={8}>
                <Card style={{ minHeight: '100%' }}>
                    <Statistic
                        title="BUGÜNKÜ ZİYARETÇİ SAYISI"
                        value={todayCount}
                        formatter={formatter}
                        prefix={<img height={34} src={todayUser} alt="Bugünkü Ziyaretçi Sayısı" />}
                    />
                </Card>
            </Col>
            <Col xs={24} sm={8}>
                <Card style={{ minHeight: '100%' }}>
                    <Statistic
                        title="TOPLAM ZİYARETÇİ SAYISI"
                        value={allCount}
                        formatter={formatter}
                        prefix={<img height={34} src={allUser} alt="Toplam Ziyaretçi Sayısı" />}
                    />
                </Card>
            </Col>
        </Row>
    );
};

export default StatsSection;